import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      {/* Hero Section */}
      <section className="hero-section hero-margin">
        <div className="hero-overlay">
          <div className="container">
            <div className="hero-content">
              <h1>Privacy Policy</h1>
              <p className="hero-tagline">Effective as of June 1, 2025</p>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="content-section">
        <div className="container">
          <div className="policy-content">
            <div className="policy-header">
              <h2> Privacy Policy</h2>
              <p className="intro-text">
                We at Trackline XR Logistics ("Trackline XR Logistics," "we," "us," or "our") created this privacy policy ("Privacy Policy") because we know that you care about how information you provide to us is used and shared. This Privacy Policy relates to the information collection and use practices of Trackline XR Logistics in connection with our online services (the "Services"), which are made available to you through our website located at https://www.tracklinexr.com/ (the "Site").
              </p>
            </div>

            <div className="policy-sections">
              {/* Information We Collect */}
              <div className="policy-section">
                <h3>Information We Collect</h3>
                
                <div className="subsection">
                  <h4>Personal Information</h4>
                  <p>We do not collect any personal information from you unless you voluntarily provide it to us.</p>
                  <p>When you sign up to become a user of the Site (a "User"), you will be asked to provide us with certain personal information, such as your first name, last name, and email address. In this Privacy Policy, we refer to this information as "Personal Information."</p>
                  <p>Other than the online contact information required to obtain parental consent, we do not collect any Personal Information from Users under the age of 13 unless the User's parent or legal guardian has first provided us with consent for that User to use the Services and disclose Personal Information to us. If you are a User under the age of 13, please do not send any Personal Information to us if we have not obtained prior consent from your parent or guardian. If we learn we have collected Personal Information from a User under the age of 13 without parental consent, or if we learn a User under the age of 13 has provided us Personal Information beyond what we request from him or her, we will delete that information as quickly as possible. If you believe that a User under the age of 13 may have provided us Personal Information in violation of this Privacy Policy, please contact us at admin@tracklinexr.com.</p>
                </div>

                <div className="subsection">
                  <h4>Usage Information</h4>
                  <p>Like most websites, we use automatic data collection technology when you visit the Site to record information that identifies your computer, to track your use of our Site, and to collect certain basic information about you and your surfing habits.</p>
                  <p>This information includes information about your operating system, your IP addresses, browser type and language, referring and exit pages and URLs, keywords, date and time, amount of time spent on particular pages, what sections of a website you visit, and similar information concerning your use of the Site and the Services (the "Usage Information").</p>
                  <p>We collect this Usage Information by using cookies and pixel tags (also called web beacons or clear gifs). Cookies are small packets of data that a website stores on your computer's hard drive so that your computer will "remember" information about your visit. Clear gifs are tiny graphics with a unique identifier, similar in function to cookies, and are used to track the online movements of website users. You can reject cookies by following the directions provided in your Internet provider's "help" file. If you reject cookies, you may still visit the Site, but may not be able to use some areas of the Site and/or the Services.</p>
                  <p>We do not collect Personal Information in this way, but if you've provided us with Personal Information, we may associate that information with the information that is collected automatically. Automatic data collection may be performed on our behalf by our services providers. Trackline XR Logistics will not share any SMS consent and phone numbers to third parties. Trackline XR Logistics will obtain consent for SMS messages through consent opt-in checkbox on our website. you can reply stop, or send an email to opt-out at any time. SMS Consent and phone numbers collected will not be shared with a third party for any purposes.</p>
                </div>
              </div>

              {/* How We Use Your Information */}
              <div className="policy-section">
                <h3>How We Use Your Information</h3>
                <p>We may use your Personal Information and Usage Information in a manner that is consistent with this Privacy Policy and the context of our relationship with you. We will use your Personal Information and Usage Information collected through the Site for the following purposes:</p>
                <ul className="usage-list">
                  <li>To identify you when you sign in to your account;</li>
                  <li>To respond to your requests and to provide you with the Services;</li>
                  <li>To respond to your inquiries and contact you about changes to the Site and/or the Services;</li>
                  <li>To send you notices (for example, in the form of e-mails, mailings, and the like) regarding products or services you are receiving, and for billing and collection purposes;</li>
                  <li>To send you information we think you may find useful or that you have requested from us;</li>
                  <li>To enhance and improve the Site or the Service, such as through personalized features and content;</li>
                  <li>To analyze the use of the Site and the Service and the people visiting to improve our content and Site and the Service;</li>
                  <li>To investigate, prevent, or take action regarding illegal activities, suspected fraud, situations involving potential threats to the physical safety of any person, violations of our policies, or as otherwise required by law;</li>
                  <li>For any other purposes disclosed at the time the information is collected or to which you consent; and</li>
                  <li>As otherwise specifically described in this Privacy Policy.</li>
                </ul>
              </div>

              {/* Disclosure of Personal Information */}
              <div className="policy-section">
                <h3>Disclosure of Personal Information to Third Parties</h3>
                <p>We do not disclose your Personal Information to third parties for their direct marketing purposes.</p>
                <p>We, like many businesses, sometimes hire other companies to perform certain business-related functions. Examples include mailing information, maintaining databases, hosting services, and processing payments. When we employ another company to perform a function of this nature, we provide them with the information that they need to perform their specific function, which may include Personal Information.</p>
                <p>If we or all or substantially all of our assets are acquired, we expect that the information that we have collected, including Personal Information, would be transferred along with our other business assets.</p>
                <p>We may disclose your Personal Information and Usage Information to government authorities and to other third parties when compelled to do so by government authorities, at our discretion, or otherwise as required by law, including but not limited to in response to court orders and subpoenas. We may also disclose your Personal Information and Usage Information when we have reason to believe that someone is or may be causing injury to or interference with our rights or property, other users of this Site, or anyone else that could be harmed by such activities.</p>
              </div>

              {/* How We Protect Your Information */}
              <div className="policy-section">
                <h3>How We Protect Your Information</h3>
                <p>We take commercially reasonable steps to protect the Personal Information from loss, misuse, and unauthorized access, disclosure, alteration, or destruction. Please understand, however, that no security system is impenetrable. We cannot guarantee the security of our databases, nor can we guarantee that the information you supply will not be intercepted while being transmitted to and from us over the Internet. In particular, e-mail sent to or from us may not be secure, and you should therefore take special care in deciding what information you send to us via e-mail.</p>
              </div>

              {/* Accessing and Modifying Account Information */}
              <div className="policy-section">
                <h3>Accessing and Modifying Account Information</h3>
                <p>You may update the information that is stored in your user account by e-mailing us at admin@tracklinexr.com</p>
                <p>We strive to help parents ensure that their kids have a safe experience using our Services. Parents or legal guardians can review any Personal Information collected about their child under 13 years of age, have this information deleted, request that there be no further collection or use of their child's Personal Information, and/or allow for our collection and use of their child's Personal Information while withholding consent for us to disclose it to third parties. We take steps to verify the identity of anyone requesting information about a child and to ensure that the person is in fact the child's parent or legal guardian.</p>
              </div>

              {/* Your Choices */}
              <div className="policy-section">
                <h3>Your Choices</h3>
                <p>If you wish to stop receiving promotional e-mails, you may do so by e-mailing admin@tracklinexr.com. You may also choose to unsubscribe from our emails by following the instructions in the bottom of the email.</p>
              </div>

              {/* Links */}
              <div className="policy-section">
                <h3>Links</h3>
                <p>The Site may contain content, services, advertising and other materials that link to websites operated by third parties. We have no control over those other sites, and this Privacy Policy does not apply to them. Please refer to the privacy policies of those sites for more information on how the operators of those sites collect and use your Personal Information.</p>
              </div>

              {/* International Users */}
              <div className="policy-section">
                <h3>Important Notice to Users Outside the U.S.</h3>
                <p>The Site and the Services are operated in the United States. If you are located outside of the United States, please be aware that any information you provide to us will be transferred to the United States. By providing us with any information through the Site or the Services, you consent to this transfer.</p>
              </div>

              {/* Changes to Policy */}
              <div className="policy-section">
                <h3>Changes to This Privacy Policy</h3>
                <p>This Privacy Policy is effective as of the date stated at the top of this Privacy Policy. We may change this Privacy Policy from time to time and will post any changes on the Site as soon as they go into effect. By accessing the Site or using the Services after we make any such changes to this Privacy Policy, you are deemed to have accepted such changes. Please refer back to this Privacy Policy on a regular basis.</p>
              </div>

              {/* Contact Information */}
              <div className="policy-section">
                <h3>How to Contact Us</h3>
                <p>If you have questions about this Privacy Policy, please e-mail us at admin@tracklinexr.com with "PRIVACY POLICY" in the subject line, or visit us at the following locations:</p>
                <div className="contact-info">
                  <p><strong>Trackline XR Logistics</strong></p>
                  <div className="location">
                    <p><strong>USA Office:</strong></p>
                    <p>9522 Majestic Canyon Ln, Houston, TX 77070</p>
                  </div>
                  <div className="location">
                    <p><strong>India Office:</strong></p>
                    <p>C-33, Phase 2, Industrial Area S.A.S Nagar, Mohali</p>
                    {/* <p>Phone: +91 9841000034</p> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .privacy-policy {
          font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          color: #333;
          line-height: 1.6;
          overflow-x: hidden;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        /* Hero Section */
        .hero-section {
  background: #00358d;
  background-position: center;
  background-attachment: scroll;
  color: white;
  padding: 110px 0;
  position: relative;
}

        .hero-margin {
          margin-left: 20px;
          margin-right: 20px;
          border-radius: 20px;
        }

        .hero-overlay {
          position: relative;
          z-index: 2;
        }

        .hero-content {
          text-align: center;
          max-width: 800px;
          margin: 0 auto;
        }

       .hero-content h1 {
  font-size: 4rem;
  
 color: white;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 3px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  margin-top: 7rem;
}

        .hero-tagline {
          font-size: 1.8rem;
          margin-bottom: 1rem;
          font-weight: 500;
          opacity: 0.95;
        }

        /* Content Section */
        .content-section {
          padding: 100px 0;
          background-color: #f8fafc;
        }

        .policy-content {
          max-width: 900px;
          margin: 0 auto;
          background: white;
          border-radius: 15px;
          padding: 60px;
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
        }

        .policy-header {
          text-align: center;
          margin-bottom: 50px;
          border-bottom: 3px solid #e30613;
          padding-bottom: 30px;
        }

        .policy-header h2 {
          font-size: 2.8rem;
          margin-bottom: 1.5rem;
          color: #1a202c;
          font-weight: 700;
        }

        .intro-text {
          font-size: 1.2rem;
          color: #666;
          line-height: 1.7;
        }

        .policy-sections {
          text-align: left;
        }

        .policy-section {
          margin-bottom: 50px;
        }

        .policy-section h3 {
          font-size: 2rem;
          margin-bottom: 1.5rem;
          color: #1a202c;
          font-weight: 700;
          border-left: 4px solid #e30613;
          padding-left: 15px;
        }

        .subsection {
          margin-bottom: 30px;
        }

        .subsection h4 {
          font-size: 1.5rem;
          margin-bottom: 1rem;
          color: #2d3748;
          font-weight: 600;
        }

        .policy-section p {
          font-size: 1.1rem;
          margin-bottom: 1.2rem;
          color: #4a5568;
          line-height: 1.7;
        }

        .usage-list {
          list-style: none;
          padding-left: 0;
        }

        .usage-list li {
          position: relative;
          padding-left: 30px;
          margin-bottom: 12px;
          font-size: 1.1rem;
          color: #4a5568;
          line-height: 1.6;
        }

        .usage-list li:before {
          content: '✓';
          position: absolute;
          left: 0;
          color: #e30613;
          font-weight: bold;
          font-size: 1.2rem;
        }

        .contact-info {
          background: #f7fafc;
          border-left: 4px solid #e30613;
          padding: 25px;
          border-radius: 8px;
          margin-top: 20px;
        }

        .location {
          margin-bottom: 20px;
          padding-bottom: 15px;
          border-bottom: 1px solid #e2e8f0;
        }

        .location:last-child {
          margin-bottom: 0;
          padding-bottom: 0;
          border-bottom: none;
        }

        .contact-info p {
          margin-bottom: 8px;
          font-size: 1.1rem;
        }

        .contact-info strong {
          color: #1a202c;
          font-size: 1.2rem;
        }

        /* Responsive Design */
        @media (max-width: 992px) {
          .policy-content {
            padding: 40px;
          }
          
          .hero-content h1 {
            font-size: 3.2rem;
          }
          
          .policy-header h2 {
            font-size: 2.4rem;
          }
        }

        @media (max-width: 768px) {
          .hero-section {
            padding: 80px 0;
            background-attachment: scroll;
          }
          
          .hero-content h1 {
            font-size: 2.5rem;
          }
          
          .hero-tagline {
            font-size: 1.5rem;
          }
          
          .content-section {
            padding: 70px 0;
          }
          
          .policy-content {
            padding: 30px;
          }
          
          .policy-header h2 {
            font-size: 2rem;
          }
          
          .policy-section h3 {
            font-size: 1.6rem;
          }
          
          .subsection h4 {
            font-size: 1.3rem;
          }
        }

        @media (max-width: 480px) {
          .container {
            padding: 0 15px;
          }
          
          .hero-content h1 {
            font-size: 2rem;
          }
          
          .hero-tagline {
            font-size: 1.2rem;
          }
          
          .policy-content {
            padding: 25px 20px;
          }
          
          .policy-header h2 {
            font-size: 1.8rem;
          }
          
          .policy-section h3 {
            font-size: 1.4rem;
          }
          
          .policy-section p {
            font-size: 1rem;
          }
          
          .contact-info {
            padding: 20px;
          }
        }
      `}</style>
    </div>
  );
};

export default PrivacyPolicy;